/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { Mesh } from 'three';
// tslint:disable-next-line:no-empty-interface
export class TileObject3D extends Mesh {
}
//# sourceMappingURL=Tile.js.map